import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async getMyMeasuresAwaitingApproval({ commit }) {
      try {
        const response = await api.get('/reports/my-measures-awaiting-approval')

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getMyMeasures({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)
        const response = await api.get(`/reports/my-measures?${params}`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getManagerPendences({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)
        const response = await api.get(`/reports/manager-pendences?${params}`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getFinancialPendences({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)
        const response = await api.get(`/reports/financial-pendences?${params}`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getMeasuresInvoiced({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)
        const response = await api.get(`/reports/measures-invoiced?${params}`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
